import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import colors from '../../../config/theme/colors';

const DescriptionText = ({ type }: { type: string }) => {
  return (
    <div style={{ color: colors.darkGray, fontSize: '1.6rem', whiteSpace: 'pre-line' }}>
      {type && (
        <FormattedMessage
          id={'cognition.' + type + '.meterDescriptionText'}
          values={{
            br: '\n',
            strong: chunks => (
              <div key={chunks.join('')} style={{ fontWeight: '600' }}>
                {React.Children.toArray(chunks)}
              </div>
            ),
          }}
        />
      )}
    </div>
  );
};

export default DescriptionText;
